import { render, staticRenderFns } from "./SvgHomePartnerPictoShopping.vue?vue&type=template&id=38246602&scoped=true"
import script from "./SvgHomePartnerPictoShopping.vue?vue&type=script&lang=js"
export * from "./SvgHomePartnerPictoShopping.vue?vue&type=script&lang=js"
import style0 from "./SvgHomePartnerPictoShopping.vue?vue&type=style&index=0&id=38246602&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38246602",
  null
  
)

export default component.exports